var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "is-required",
                                    attrs: {
                                      label: "窗口期",
                                      prop: "windowTimeList",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "multiple_sel",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          multiple: "",
                                          placeholder: "请选择(支持多选)",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.windowTimeList,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "windowTimeList",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.windowTimeList",
                                        },
                                      },
                                      _vm._l(
                                        _vm.windowTimeList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.name,
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品编码",
                                      prop: "griCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.griCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "griCode",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.griCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品中文名称",
                                      prop: "griDescription",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.queryCondition.griDescription,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "griDescription",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.griDescription",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品英文名称",
                                      prop: "griName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.griName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "griName",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.griName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Category2",
                                              prop: "categoryLevel2CodesList",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder:
                                                    "请选择(支持多选)",
                                                },
                                                on: {
                                                  change: _vm.changeCategory2,
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .categoryLevel2CodesList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "categoryLevel2CodesList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.categoryLevel2CodesList",
                                                },
                                              },
                                              _vm._l(
                                                _vm.categoryList2,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Category3",
                                              prop: "categoryLevel3CodesList",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder:
                                                    "请选择(支持多选)",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .categoryLevel3CodesList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "categoryLevel3CodesList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.categoryLevel3CodesList",
                                                },
                                              },
                                              _vm._l(
                                                _vm.categoryList3,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "波动比例超过20%",
                                              prop: "alertFlag",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .alertFlag,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "alertFlag",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.alertFlag",
                                                },
                                              },
                                              _vm._l(
                                                _vm.alertFlagOptions,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTR_REPORT_CONFIRM_EDITION,
                    expression: "NUTR_REPORT_CONFIRM_EDITION",
                  },
                ],
                staticClass: "btn",
                attrs: {
                  size: "mini",
                  type: "primary",
                  disabled: _vm.isFinalDisabled,
                  loading: _vm.isFinalLoading,
                },
                on: { click: _vm.onFinalization },
              },
              [_vm._v("定版")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTR_REPORT_RELEASE,
                    expression: "NUTR_REPORT_RELEASE",
                  },
                ],
                staticClass: "btn",
                attrs: {
                  size: "mini",
                  type: "primary",
                  disabled: _vm.isPublishDisabled,
                  loading: _vm.isPublishLoading,
                },
                on: { click: _vm.onPublish },
              },
              [_vm._v("发布")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTR_REPORT_DOWNLOAD,
                    expression: "NUTR_REPORT_DOWNLOAD",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onExport },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "border-card" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              _vm._l(_vm.tabLists, function (item, index) {
                return _c(
                  "el-tab-pane",
                  { key: index, attrs: { name: item.key, label: item.label } },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "refTable",
                        refInFor: true,
                        staticClass: "nutritionTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: item.currentDetailList,
                          "cell-class-name": _vm.cellClassName,
                          "row-key": "REPORT_ID",
                          "expand-row-keys": _vm.expandKeys,
                          "max-height": "425",
                          border: "",
                        },
                        on: { "expand-change": _vm.expandChange },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "expand" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-table",
                                      {
                                        staticClass: "nutritionTable",
                                        staticStyle: {
                                          width: "calc(100% - 34px)",
                                          "margin-left": "41px!important",
                                        },
                                        attrs: {
                                          data: scope.row.childDetailList,
                                          "cell-class-name": _vm.cellClassName,
                                          "max-height": "425",
                                          border: "",
                                          "row-key": "REPORT_ID",
                                        },
                                      },
                                      _vm._l(
                                        _vm.childTableHeaderList,
                                        function (item, index) {
                                          return _c("el-table-column", {
                                            key: index,
                                            attrs: {
                                              prop: item.prop,
                                              label: item.label,
                                              width: "150",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      scope.row[item.prop] &&
                                                      scope.row[
                                                        item.prop +
                                                          "_GAP_REASON"
                                                      ]
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  scope.row[
                                                                    item.prop +
                                                                      "_GAP_REASON"
                                                                  ],
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "nutrition_p",
                                                                },
                                                                [
                                                                  item.prop !=
                                                                    "WINDOW_TIME" &&
                                                                  item.prop !=
                                                                    "ATTACHMENTINFO" &&
                                                                  item.prop !=
                                                                    "CURRENT_IMPACT" &&
                                                                  item.prop !=
                                                                    "FIVE_BIT_CODE" &&
                                                                  item.prop !=
                                                                    "INSPECT_ID" &&
                                                                  item.prop !=
                                                                    "VERSION" &&
                                                                  item.prop !=
                                                                    "BE_SELECTED_REASON" &&
                                                                  item.prop !=
                                                                    "FACILITY_NAME" &&
                                                                  item.prop !=
                                                                    "DELIVERY_RATIO"
                                                                    ? _c(
                                                                        "el-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: "text",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onViewChildReason(
                                                                                  scope.row,
                                                                                  item.prop,
                                                                                  item.label
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              scope
                                                                                .row[
                                                                                item
                                                                                  .prop
                                                                              ]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              scope
                                                                                .row[
                                                                                item
                                                                                  .prop
                                                                              ]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "nutrition_p",
                                                            },
                                                            [
                                                              item.prop !=
                                                                "WINDOW_TIME" &&
                                                              item.prop !=
                                                                "ATTACHMENTINFO" &&
                                                              item.prop !=
                                                                "CURRENT_IMPACT" &&
                                                              item.prop !=
                                                                "FIVE_BIT_CODE" &&
                                                              item.prop !=
                                                                "INSPECT_ID" &&
                                                              item.prop !=
                                                                "VERSION" &&
                                                              item.prop !=
                                                                "BE_SELECTED_REASON" &&
                                                              item.prop !=
                                                                "FACILITY_NAME" &&
                                                              item.prop !=
                                                                "DELIVERY_RATIO"
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type: "text",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onViewChildReason(
                                                                              scope.row,
                                                                              item.prop,
                                                                              item.label
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          scope
                                                                            .row[
                                                                            item
                                                                              .prop
                                                                          ]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : item.prop ==
                                                                  "FIVE_BIT_CODE"
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type: "text",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.goToNutritionDetail(
                                                                              scope.row
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          scope
                                                                            .row[
                                                                            item
                                                                              .prop
                                                                          ]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : item.prop ==
                                                                  "VERSION"
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type: "text",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onViewDetail(
                                                                              scope.row
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          scope
                                                                            .row[
                                                                            item
                                                                              .prop
                                                                          ]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : item.prop ==
                                                                  "ATTACHMENTINFO"
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type: "text",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onViewFile(
                                                                              scope.row
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "附件"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        scope
                                                                          .row[
                                                                          item
                                                                            .prop
                                                                        ]
                                                                      )
                                                                    ),
                                                                  ]),
                                                            ],
                                                            1
                                                          ),
                                                      scope.row[
                                                        item.prop +
                                                          "_ALERT_FLAG"
                                                      ] == "Y" &&
                                                      scope.row[
                                                        item.prop +
                                                          "_GAP_PERCENT_PRE_WINDOW"
                                                      ]
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "nutrition_p_span",
                                                            },
                                                            [
                                                              _c("i", {
                                                                class:
                                                                  Number(
                                                                    scope.row[
                                                                      item.prop +
                                                                        "_GAP_PERCENT_PRE_WINDOW"
                                                                    ]
                                                                  ) > 0
                                                                    ? "el-icon-top"
                                                                    : "el-icon-bottom",
                                                              }),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    Math.abs(
                                                                      scope.row[
                                                                        item.prop +
                                                                          "_GAP_PERCENT_PRE_WINDOW"
                                                                      ]
                                                                    ) + "%"
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._l(item.tableHeaderList, function (item, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: item.prop,
                              label: item.label,
                              width: "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row[item.prop] &&
                                      scope.row[item.prop + "_GAP_REASON"]
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  scope.row[
                                                    item.prop + "_GAP_REASON"
                                                  ],
                                                placement: "top",
                                              },
                                            },
                                            [
                                              item.prop != "WINDOW_TIME" &&
                                              item.prop != "CURRENT_IMPACT" &&
                                              item.prop != "GRI_CODE" &&
                                              item.prop != "DESCRIBE" &&
                                              item.prop !=
                                                "FIVE_BIT_CODE_NAME" &&
                                              item.prop !=
                                                "CATEGORY_LEVEL2_NAME" &&
                                              item.prop !=
                                                "CATEGORY_LEVEL3_NAME" &&
                                              item.prop != "COOK_CODE"
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onViewReason(
                                                            scope.row,
                                                            item.prop,
                                                            item.label
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row[item.prop]
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "nutrition_p",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row[item.prop]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "p",
                                            { staticClass: "nutrition_p" },
                                            [
                                              item.prop != "WINDOW_TIME" &&
                                              item.prop != "CURRENT_IMPACT" &&
                                              item.prop != "GRI_CODE" &&
                                              item.prop != "DESCRIBE" &&
                                              item.prop !=
                                                "FIVE_BIT_CODE_NAME" &&
                                              item.prop !=
                                                "CATEGORY_LEVEL2_NAME" &&
                                              item.prop !=
                                                "CATEGORY_LEVEL3_NAME" &&
                                              item.prop != "COOK_CODE"
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onViewReason(
                                                            scope.row,
                                                            item.prop,
                                                            item.label
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row[item.prop]
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row[item.prop]
                                                      )
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          ),
                                      scope.row[item.prop + "_ALERT_FLAG"] ==
                                        "Y" &&
                                      scope.row[
                                        item.prop + "_GAP_PERCENT_PRE_WINDOW"
                                      ]
                                        ? _c(
                                            "p",
                                            { staticClass: "nutrition_p_span" },
                                            [
                                              _c("i", {
                                                class:
                                                  Number(
                                                    scope.row[
                                                      item.prop +
                                                        "_GAP_PERCENT_PRE_WINDOW"
                                                    ]
                                                  ) > 0
                                                    ? "el-icon-top"
                                                    : "el-icon-bottom",
                                              }),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.abs(
                                                      scope.row[
                                                        item.prop +
                                                          "_GAP_PERCENT_PRE_WINDOW"
                                                      ]
                                                    ) + "%"
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "pagination" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.queryCondition.pageNum,
                            "page-sizes": _vm.pageSizeList,
                            "page-size": _vm.queryCondition.pageSize,
                            layout: _vm.pageLayout,
                            total: _vm.totalCount,
                            "page-count": _vm.pages,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "波动原因备注",
              visible: _vm.dialogVisible1,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible1 = $event
              },
              close: _vm.onClose1,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "remarkForm",
                attrs: { model: _vm.remarkForm, "label-width": "100px" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "产品编码", prop: "griCode" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.remarkForm.griCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.remarkForm, "griCode", $$v)
                        },
                        expression: "remarkForm.griCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "产品中文名称", prop: "griName" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.remarkForm.griName,
                        callback: function ($$v) {
                          _vm.$set(_vm.remarkForm, "griName", $$v)
                        },
                        expression: "remarkForm.griName",
                      },
                    }),
                  ],
                  1
                ),
                _vm.isDisplay
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "工厂名称", prop: "plantName" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.remarkForm.plantName,
                            callback: function ($$v) {
                              _vm.$set(_vm.remarkForm, "plantName", $$v)
                            },
                            expression: "remarkForm.plantName",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "Nutrition指标", prop: "indicators" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.remarkForm.indicators,
                        callback: function ($$v) {
                          _vm.$set(_vm.remarkForm, "indicators", $$v)
                        },
                        expression: "remarkForm.indicators",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "波动原因备注",
                      prop: "gapReason",
                      rules: {
                        required: true,
                        message: "波动原因备注必填",
                        trigger: "blur",
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 4,
                        maxlength: "1000",
                        "show-word-limit": "",
                        disabled: !_vm.isEdit,
                      },
                      model: {
                        value: _vm.remarkForm.gapReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.remarkForm, "gapReason", $$v)
                        },
                        expression: "remarkForm.gapReason",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _vm.isEdit
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: {
                          size: "mini",
                          type: "primary",
                          disabled: _vm.isSaveDisabled,
                          loading: _vm.isSaveLoading,
                        },
                        on: { click: _vm.onSaveNote },
                      },
                      [_vm._v("保存")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose1 },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "附件信息",
              visible: _vm.dialogVisible2,
              width: "70%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible2 = $event
              },
              close: _vm.onClose2,
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "fileTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.fileTableData,
                  "max-height": "326px",
                  border: "",
                  size: "small",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", type: "index", "min-width": "50px" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "附件类型",
                    prop: "attachmentTypeText",
                    "show-overflow-tooltip": "",
                    "min-width": "100px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "附件名称",
                    prop: "documentName",
                    "show-overflow-tooltip": "",
                    "min-width": "180px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDownload(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.documentName))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "上传人",
                    prop: "uploadBy",
                    "show-overflow-tooltip": "",
                    "min-width": "100px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "上传时间",
                    prop: "uploadTime",
                    "show-overflow-tooltip": "",
                    "min-width": "100px",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose2 },
                  },
                  [_vm._v("返回")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "Nutrition修改",
              visible: _vm.dialogVisible3,
              width: "80%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible3 = $event
              },
              close: _vm.onClose3,
            },
          },
          [
            _c("detailDialog", {
              attrs: { detailObj: _vm.detailObj },
              on: { closeDetail: _vm.closeDetail, onClose3: _vm.onClose3 },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }